import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import StoreContext from "./context/Store";
import ReCaptchaProvider from "./context/recaptchaProvider";
import SocketProvider from "./context/SocketProvider";
import { AuthProvider } from "./shared/auth/AuthContext";
import { queryClient } from "./shared/api/queryClient";

import { checkPermission } from "./helpers/permissions";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <StoreContext>
          <ReCaptchaProvider>
            <SocketProvider>
              <App />
            </SocketProvider>
          </ReCaptchaProvider>
        </StoreContext>
      </AuthProvider>
      {/* DevTools only render in dev builds; safe to leave permanently */}
      {/* Note: <Toaster /> is mounted in App.js — don't add another here. */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.Fragment>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (checkPermission("manage_texting")) {
  serviceWorkerRegistration.register();
}

reportWebVitals();
